<template lang="pug">
.back-btn-wrapper
  .back-btn(@click="goBack()")
    svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
      line(x1='19' y1='12' x2='5' y2='12')
      polyline(points='12 19 5 12 12 5')  
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    }
  },
  methods: {
    goBack() {
      if(this.$route.query.from) {
        this.$router.push(this.$route.query.from);
      } else if(this.name) {
        this.$router.push({name: this.name})
      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.back-btn-wrapper {
  margin: 0 0 $sm-space 0;
  .back-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    border-radius: 12px;
    border: solid 1px $lightgray;
    color: $darkgray;
    cursor: pointer;
    &:hover {
      background-color: $light;
    }
  }
}
</style>